var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rechteck_12535",
    x: 0,
    y: 0,
    width: 42,
    height: 44,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#101828",
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_40894",
    "data-name": "Gruppe 40894",
    transform: "translate(-559 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 559, 188)",
    filter: "url(#Rechteck_12535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rechteck_12535-2",
    "data-name": "Rechteck 12535",
    transform: "translate(3 2)",
    fill: "#fff",
    stroke: "#efefef",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 38,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 34.5,
    height: 36.5,
    rx: 7.25,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2141",
    "data-name": "Gruppe 2141",
    transform: "translate(569.957 194.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_352",
    "data-name": "Pfad 352",
    d: "M144.861,78.321a5.771,5.771,0,0,0,1.457,5.814,5.637,5.637,0,0,0,4.078,1.717,6.076,6.076,0,0,0,1.094-.1V90.2a.679.679,0,0,0,1.359,0V85.751a6.084,6.084,0,0,0,1.1.1,5.638,5.638,0,0,0,4.078-1.717,5.771,5.771,0,0,0,1.457-5.814.679.679,0,0,0-.419-.447,4.832,4.832,0,0,0-.9-.21A5.773,5.773,0,0,0,159.487,72a.679.679,0,0,0-.419-.447,5.847,5.847,0,0,0-3.654.038,6.1,6.1,0,0,0,.17-1.451A5.771,5.771,0,0,0,152.5,65a.679.679,0,0,0-.612-.02,5.75,5.75,0,0,0-3.12,5.162,6.1,6.1,0,0,0,.17,1.454,5.847,5.847,0,0,0-3.662-.041.68.68,0,0,0-.419.447,5.773,5.773,0,0,0,1.315,5.667,4.832,4.832,0,0,0-.9.21A.68.68,0,0,0,144.861,78.321Zm12.208,4.853a4.385,4.385,0,0,1-4.109,1.215,4.407,4.407,0,0,1,1.214-4.111,4.486,4.486,0,0,1,1.532-1.021q.145-.047.292-.1a4.516,4.516,0,0,1,2.283-.092A4.381,4.381,0,0,1,157.068,83.174Zm1.211-10.435a4.381,4.381,0,0,1-1.211,4.112,4.486,4.486,0,0,1-1.528,1.019q-.148.047-.3.105a4.513,4.513,0,0,1-2.285.091,4.562,4.562,0,0,1-.106-.957c0-.006,0-.012,0-.017a4.3,4.3,0,0,1,1.05-2.844c.1-.1.2-.206.3-.321A4.385,4.385,0,0,1,158.279,72.739Zm-6.106-6.365a4.381,4.381,0,0,1,2.051,3.764A4.333,4.333,0,0,1,153.208,73c-.11.11-.213.221-.31.333a4.562,4.562,0,0,1-.72.572,4.62,4.62,0,0,1-.831-.687l-.1-.1a4.334,4.334,0,0,1-1.121-2.974A4.385,4.385,0,0,1,152.174,66.374Zm-6.106,6.366a4.406,4.406,0,0,1,4.107,1.215l.029.03q.089.1.179.192a4.3,4.3,0,0,1,1.107,2.681v.453a4.527,4.527,0,0,1-.1.754,4.515,4.515,0,0,1-2.287-.091q-.147-.057-.293-.1a4.486,4.486,0,0,1-1.531-1.02A4.381,4.381,0,0,1,146.068,72.74Zm0,6.323a4.556,4.556,0,0,1,2.334.11q.1.036.194.069a4.454,4.454,0,0,1,1.579,1.036,4.331,4.331,0,0,1,1.315,2.9v.453a4.529,4.529,0,0,1-.1.754,4.482,4.482,0,0,1-5.322-5.325Z",
    transform: "translate(-144.606 -64.913)",
    fill: "#1c9d87"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_355",
    "data-name": "Ellipse 355",
    cx: 5.302,
    cy: 5.302,
    r: 5.302,
    transform: "translate(8.938 17.806)",
    fill: "#f3fffd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-minus-circle",
    "data-name": "Icon awesome-minus-circle",
    d: "M4.682.562A4.12,4.12,0,1,0,8.8,4.682,4.119,4.119,0,0,0,4.682.562ZM2.489,5.347a.2.2,0,0,1-.2-.2v-.93a.2.2,0,0,1,.2-.2H6.875a.2.2,0,0,1,.2.2v.93a.2.2,0,0,1-.2.2Z",
    transform: "translate(9.569 18.433)",
    fill: "#1c9d87"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower);
export default __webpack_public_path__ + "static/media/flower.9e6fbdb3d8f27c75175c87efeac725a6.svg";
export { ForwardRef as ReactComponent };